import { AssetDto, AssetVersionDto, AssetVideoTypeDataDto } from '@nusign/picflow-backend-types';
import { specialCaseFormats } from '../consts';
import { getExtension } from './get-extension';
import { isImagesBucketAsset } from './is-images-bucket-asset';

export const calcResizedUrlFromUuid = (
  cdn: string,
  uuid: string,
  paramString: string,
  canUseSpecialVersion = false
) => {
  return `${cdn}/images/resized/${paramString}/${uuid}.${canUseSpecialVersion ? 'webp' : 'jpg'}`;
};

export const calcResizedUrl = (
  cdn: string,
  asset: AssetDto,
  version: AssetVersionDto,
  paramString: string,
  watermark: boolean,
  allowSpecialVersion = false,
  newExtension?: string,
  page = 0
) => {
  const ext =
    newExtension ??
    (allowSpecialVersion && specialCaseFormats.includes(getExtension(version.asset_name)) ? 'webp' : 'jpg');

  if (asset.type === 'image' && isImagesBucketAsset(asset, version)) {
    const uuid = watermark ? version.watermark_uuid || version.uuid : version.uuid;
    return `${cdn}/images/resized/${paramString}/${uuid}.${ext}`;
  }

  if (asset.type === 'video') {
    const data = version.data as AssetVideoTypeDataDto;
    const posterUrl = data.poster_url; // https://assets.dev.picflow.io/images/e593cb09-1392-46fb-84e9-7fde0bc34b8c/base/e593cb09-1392-46fb-84e9-7fde0bc34b8c.jpg
    const posterKey = posterUrl.split('/images/')[1]; // e593cb09-1392-46fb-84e9-7fde0bc34b8c/base/e593cb09-1392-46fb-84e9-7fde0bc34b8c.jpg
    const uuid = posterKey.split('/')[0]; // e593cb09-1392-46fb-84e9-7fde0bc34b8c
    return `${cdn}/images/resized/${paramString}/${uuid}.${ext}`;
  }

  const prefix = version.original_key.split('/')[0]; // pdf
  if (asset.type === 'document') {
    const key = version.data['images'][page].key; // pdf/2f9bf304-45f3-4447-958f-08243ab1575d/2f9bf304-45f3-4447-958f-08243ab1575d-page-1.jpeg
    const uuid = version.uuid; // 2f9bf304-45f3-4447-958f-08243ab1575d
    const pagePath = key.split('/').pop(); // 2f9bf304-45f3-4447-958f-08243ab1575d-page-1.jpeg
    return `${cdn}/assets/${prefix}/${uuid}/resized/${paramString}/${pagePath}`;
  }

  const uuid = version.uuid;
  return `${cdn}/assets/${prefix}/${uuid}/resized/${paramString}/${uuid}-base.jpg`;
};
